// R2 公共资源域名（方便切换 CDN 或路径）
const R2_BASE_URL = "https://pub-0f9c49dcde884c17995c23a801ee5836.r2.dev";

export const R2_VIDEOS = {
  backgroundLoop: `${R2_BASE_URL}/BackGroundLoop.mp4`,
  onSelected: `${R2_BASE_URL}/Home/OnSelectedFinal.mp4`,
  standStill: `${R2_BASE_URL}/Home/StandStillFinal.mp4`,
};

export const R2_IMAGES = {
  // Home images
  backgroundImg: `${R2_BASE_URL}/Home/Background.png`,
  backgroundPoster: `${R2_BASE_URL}/Home/Background.png`,
  yichuanPoster: `${R2_BASE_URL}/Home/YichuanFinal.png`,
  projectImage: `${R2_BASE_URL}/Home/CHILBW_Header.png`,
  researchAreaImg: `${R2_BASE_URL}/Home/ResearchArea.png`,
  
  // Institution logos
  hkustLogo: `${R2_BASE_URL}/Home/HKUST-Black.png`,
  bristolLogo: `${R2_BASE_URL}/Home/Bristol-Black.png`,
  memoriesAILogo: `${R2_BASE_URL}/Home/MemoriesAI.png`,
  xjtluLogo: `${R2_BASE_URL}/Home/XJTLU-Black.png`,
  
  // About images
  profileImage: `${R2_BASE_URL}/About/Profile.jpg`,
  
  // Publications images
  chi2024: `${R2_BASE_URL}/assets/publications/chi2024.png`,
  ieee2023: `${R2_BASE_URL}/assets/publications/ieee2023.png`,
  
  // 新增的论文头图
  aamasHeader: `${R2_BASE_URL}/Home/AAMAS_Header.png`,
  chiLbwHeader: `${R2_BASE_URL}/Home/CHILBW_Header.png`,
  tvcgHeader: `${R2_BASE_URL}/Home/TVCG_Header.png`,
  ismarWorkshopHeader: `${R2_BASE_URL}/Home/ISMARWorkShop_Header.png`,
  gameVFX1: `${R2_BASE_URL}/Home/GameVFX1.png`,
  gameVFX2: `${R2_BASE_URL}/Home/GameVFX2.gif`,
  gameVFX3: `${R2_BASE_URL}/Home/GameVFX3.gif`,
  gameVFX4: `${R2_BASE_URL}/Home/GameVFX4.png`,
  gameVFX5: `${R2_BASE_URL}/Home/GameVFX5.png`,
    // ✅ 新增的四个 publication 封面图
  tvcg25: `${R2_BASE_URL}/Home/TVCG2025.pdf`,
  chi25: `${R2_BASE_URL}/Home/CHI2025.pdf`,
  ismar25: `${R2_BASE_URL}/Home/ISMAR2025.pdf`,
  aamas24: `${R2_BASE_URL}/Home/AAMAS2024.pdf`,

  tvcgLaser: `${R2_BASE_URL}/Works/TVCG_Page/Laser.png`,
  taskDesign: `${R2_BASE_URL}/Works/TVCG_Page/TaskDesgin.png`,
  allObjectiveData: `${R2_BASE_URL}/Works/TVCG_Page/ALLObjectiveData.png`,
  candidateModelFitting: `${R2_BASE_URL}/Works/TVCG_Page/CandidateModelFitting.png`,
  tvcgApplication: `${R2_BASE_URL}/Works/TVCG_Page/Applications.png`
};

export function getR2VideoPath(filename) {
    return `${R2_BASE_URL}/${filename}`;
}

export function getR2ImagePath(filename) {
    return `${R2_BASE_URL}/${filename}`;
}